var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Item"},[_c('headerItem',{attrs:{"msg":"银行列表","bgColor":"","titleBeforeColor":"","rightIcon":""}}),_c('div',{staticClass:"grid-container"},[_c('dv-scroll-board',{staticClass:"f-10",staticStyle:{"width":"100%","height":"400px"},attrs:{"config":_vm.config,"waitTime":2000000}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }